export default "__VITE_ASSET__dc97256e__"